import { Link } from "react-router-dom";
import { routes } from "routes";
import { ReactComponent as RgLogo } from "components/icons/RGLogo.svg";
import "./RGLogo.scss";

export const RGLogo = () => {
  return (
    <Link to={routes.home()} className="mainLogo" title="Back to home page">
      <RgLogo />
    </Link>
  );
};
